<template>
  <div class="tinymceVue-Box">
    <div class="tinymceVue" :style="{'min-height': '200px'}" >
      <div :id="tinymceID"></div>
    </div>
  </div>
</template>
<script>
import '@/utils/tinymce/skins/ui/oxide/skin.min.css'

const defaultOpt = JSON.stringify({
  base_url: '/tinymce',
  language: 'zh_CN',
})
export default {
  name: 'TinymceVue2',
  props: {
    options: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tinymceID: `tinymce-${new Date().getTime()}${Math.floor(Math.random() * 10)}${Math.floor(Math.random() * 10)}`,
    }
  },
  created() {
    setTimeout(() => {
      if (typeof tinymce === 'undefined') {
        clearInterval(this.tinymceTimerID)
        throw new Error('tinymce undefined')
      }
    }, 3000)
    this.tinymceTimerID = setInterval(() => {
      if (typeof tinymce !== 'undefined') {
        this.init()
        clearInterval(this.tinymceTimerID)
      }
    }, 10)
  },
  methods: {
    init() {
      const that = this
      const defaultOptions = JSON.parse(defaultOpt)
      defaultOptions.selector = `#${that.tinymceID}`
      Object.assign(defaultOptions, this.options || {})
      // eslint-disable-next-line no-undef
      tinymce.init(defaultOptions)
    },
  },
}
</script>
<style scoped>

 .loading{
    position: relative;
 }
 .tinymce_loading{
     position:absolute;
     top: 0;
     left: 0;
     background: rgba(0,0,0,0.6);
     z-index: 99999;
     opacity: 0;
     pointer-events: none;
     /* transition: all 0.3s; */
     width: 100%;
     height: 100%;
 }
 .loading .tinymce_loading{
     opacity: 1;
 }
</style>
